export default "__VITE_ASSET__8511ee5b__"